import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GenericModal from "./GenericModal";
import { fetchOnboardingReferrals } from "./redux/slices/onboardingReferralsSlice";
import ReferAFriendModal from "./ReferAFriendModal";

export default function Referafriendone() {
  const dispatch = useDispatch();
  const { list, error } = useSelector((state) => state.onboardingReferrals);
  const [openReferAFriendModal, setOpenReferAFriendModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const tableHeadersFriendsReferred = [
    { label: "Friend Name", flex: 1 },
    { label: "Friend Email", flex: 1 },
    { label: "Reward", flex: 1 },
    { label: "Status", flex: 1 },
    { label: "Date Referred", flex: 1 },
  ];

  const tableColumnsFriendsReferred = [
    { key: "friend_name", flex: 1 },
    { key: "friend_email", flex: 1 },
    { key: "reward", flex: 1 },
    { key: "reward_status", flex: 1 },
    { key: "date_referred", flex: 1 },
  ];

  const totalSuccessfulReferrals = list.filter(
    (ref) => ref.reward_status === "rewarded"
  ).length;

  const totalEarned = list.reduce((sum, ref) => {
    const amount = parseFloat(ref.reward.replace("£", "")) || 0;
    return ref.reward_status === "rewarded" ? sum + amount : sum;
  }, 0);

  const filteredList = list.filter((ref) => {
    const query = searchQuery.toLowerCase();
    return (
      ref.friend_name.toLowerCase().includes(query) ||
      ref.friend_email.toLowerCase().includes(query) ||
      ref.status.toLowerCase().includes(query) ||
      ref.date_referred.toLowerCase().includes(query)
    );
  });

  useEffect(() => {
    dispatch(fetchOnboardingReferrals());
  }, [dispatch]);

  return (
    <RootWrapperReferafriendone>
      <Dashboard>
        <Wrapper>
          <DashboardHeader>
            <HeaderContent>
              <HeaderTitle>Refer a Friend</HeaderTitle>
              <HeaderSubtitle>Get more rewards by referring</HeaderSubtitle>
            </HeaderContent>
            <HeaderActions>
              <AIMEButton
                size="small"
                onClick={() => setOpenReferAFriendModal(true)}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "48px",
                  background: "rgb(33, 37, 67)",
                  padding: "16px 32px",
                  whiteSpace: "nowrap",
                  "@media (max-width: 767px)": {
                    padding: "12px 24px",
                    fontSize: "14px",
                  },
                  "&:hover": {
                    background: "rgb(33, 37, 67)",
                    opacity: "0.7",
                  },
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "600",
                    lineHeight: "110%",
                  }}
                >
                  Refer a Friend
                </span>
              </AIMEButton>
            </HeaderActions>
          </DashboardHeader>

          <QuickAnalytics>
            <AnalyticsCard>
              <CardContent>
                <PRTNR.StatusBadge status={"successful"} />
                <CardInfo>
                  <CardLabel>Friends Referred</CardLabel>
                  <CardValue>{totalSuccessfulReferrals}</CardValue>
                </CardInfo>
              </CardContent>
            </AnalyticsCard>

            <AnalyticsCard>
              <CardContent>
                <PRTNR.StatusBadge />
                <CardInfo>
                  <CardLabel>Earnings from Friends</CardLabel>
                  <CardValue>£{totalEarned}</CardValue>
                </CardInfo>
              </CardContent>
            </AnalyticsCard>
          </QuickAnalytics>

          <DashboardData>
            <ReferralsSection>
              <SectionCard>
                <SectionHeader>
                  <SectionTitle>
                    <SectionTitleText>Friends Referred</SectionTitleText>
                  </SectionTitle>
                  <SearchContainer>
                    <PRTNR.Input
                      type="text"
                      placeholder="Search by name, email, status, or date"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </SearchContainer>
                </SectionHeader>

                <TableWrapper>
                  <PRTNR.TableComponent
                    tableHeaders={tableHeadersFriendsReferred}
                    tableColumns={tableColumnsFriendsReferred}
                    tableData={filteredList}
                  />
                </TableWrapper>
              </SectionCard>
            </ReferralsSection>
          </DashboardData>
        </Wrapper>
      </Dashboard>

      <GenericModal
        isOpen={openReferAFriendModal}
        onClose={() => setOpenReferAFriendModal(false)}
      >
        <ReferAFriendModal
          isOpen={openReferAFriendModal}
          onClose={() => setOpenReferAFriendModal(false)}
        />
      </GenericModal>
    </RootWrapperReferafriendone>
  );
}

const RootWrapperReferafriendone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  gap: 24px;
  padding-block: clamp(1rem, 5vw, 3.75rem);
  min-height: 100vh;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: rgb(241, 245, 249);
  box-sizing: border-box;
  padding-inline: clamp(1rem, 5vw, 3.75rem);

  @media (max-width: 767px) {
    padding-inline: 1rem;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  gap: 16px;

  @media (max-width: 767px) {
    gap: 12px;
  }
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  padding: 32px 0px;

  @media (max-width: 767px) {
    flex-direction: row;
    align-items: flex-start;
    padding: 24px 0px;
    gap: 16px;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 0px;
    gap: 16px;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const HeaderTitle = styled.h1`
  color: rgb(33, 37, 67);
  font-size: clamp(24px, 5vw, 48px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  margin: 0;
  line-height: 1.2;
`;

const HeaderSubtitle = styled.p`
  color: rgb(33, 37, 67);
  font-size: clamp(0.875rem, 2.5vw, 1.125rem);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  margin: 0;
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
`;

const QuickAnalytics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const AnalyticsCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  background: rgb(255, 255, 255);
  padding: 24px;
  box-sizing: border-box;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 4px 8px rgba(10, 13, 20, 0.08);
  }

  @media (max-width: 767px) {
    padding: 20px;
  }
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const CardLabel = styled.span`
  color: rgb(100, 116, 139);
  font-size: clamp(14px, 2vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
`;

const CardValue = styled.span`
  color: rgb(33, 37, 67);
  font-size: clamp(24px, 4vw, 30px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 1.2;
`;

const DashboardData = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 0px;

  @media (max-width: 767px) {
    padding: 16px 0px;
  }
`;

const ReferralsSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  box-sizing: border-box;
`;

const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  background: rgb(255, 255, 255);
  padding: 24px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    padding: 16px;
    gap: 12px;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;

  @media (max-width: 767px) {
    flex: none;
    width: 100%;
  }
`;

const SectionTitleText = styled.span`
  color: rgb(33, 37, 67);
  font-size: clamp(16px, 2vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 280px;

  @media (max-width: 767px) {
    min-width: auto;
    width: 100%;
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  border-radius: 8px;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  @media (max-width: 767px) {
    margin: 0 -16px;
    width: calc(100% + 32px);
    padding: 0 16px;
  }
`;
